<form [formGroup]="form" style="min-width: 500px">
  <base-form-header
    createLabel="Générer une clé API"
  ></base-form-header>

  <mat-dialog-content fxLayout="column">

    <!-- Formulaire de création -->
    <ng-container *ngIf="!generatedKey">
      <base-form-input
        label="Libellé"
        controlName="label"
        type="text"
        placeholder="Ex: Clé ERP production"
        [formGroup]="form"
      ></base-form-input>
    </ng-container>

    <!-- Affichage one-shot de la clé générée -->
    <ng-container *ngIf="generatedKey">
      <base-banner-message
        text="<strong>Copiez cette clé maintenant.</strong> Elle ne sera plus affichée après fermeture de cette fenêtre."
        alertType="warn"
        [noMargin]="true"
      ></base-banner-message>

      <div class="bg-gray-100 rounded p-3 flex items-center justify-between gap-3 mt-4">
        <code class="text-xs break-all flex-1 select-all">{{ generatedKey }}</code>
        <button mat-icon-button (click)="copyKey()" [matTooltip]="keyCopied ? 'Copié !' : 'Copier'">
          <mat-icon>{{ keyCopied ? 'check' : 'content_copy' }}</mat-icon>
        </button>
      </div>
    </ng-container>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <ng-container *ngIf="!generatedKey">
      <base-form-input
        type="submit"
        [loading]="loading"
        [mode]="crudMode"
        createLabel="Générer"
        (onCreate)="generate()"
      ></base-form-input>
    </ng-container>
    <ng-container *ngIf="generatedKey">
      <button mat-raised-button color="primary" (click)="close()">Fermer</button>
    </ng-container>
  </mat-dialog-actions>
</form>
